import React from 'react'
import { SmartRouterProvider, SmartRoute, useRouter, ProtectedRoute } from './lib/SmartRouter'
import { EnhancedRegistrationForm } from './components/EnhancedRegistrationForm'
import { LoginPage } from './components/LoginPage'
import { UnifiedDashboard } from './components/UnifiedDashboard'
import { CertificateCreationForm } from './components/CertificateCreationForm'
import CertificateList from './components/CertificateList'
import { PublicCertificatePage } from './components/PublicCertificateView'
import { PhotoUpload } from './pages/PhotoUpload'
import { DebugRouter } from './components/DebugRouter'
import './components/EnhancedRegistrationForm.css'
import './components/CertificateCreationForm.css'
import './components/CertificateList.css'
import './components/PublicCertificateView.css'
import './App.css'

// 404 Page Component
const NotFoundPage: React.FC = () => (
  <div className="enhanced-registration-container">
    <div className="registration-panel">
      <div className="form-header">
        <h1>Page Not Found</h1>
      </div>
      <div className="status-feedback-box">
        <div className="status-message error">
          <span className="status-text">The page you're looking for doesn't exist.</span>
        </div>
      </div>
    </div>
  </div>
)

// Pending Approval Page
const PendingApprovalPage: React.FC = () => (
  <div className="enhanced-registration-container">
    <div className="registration-panel">
      <div className="form-header">
        <h1>Pending Approval</h1>
      </div>
      <div className="status-feedback-box">
        <div className="status-message info">
          <span className="status-text">
            Your account is pending admin approval. Please contact an administrator to activate your account.
          </span>
        </div>
      </div>
    </div>
  </div>
)

// Unauthorized Page
const UnauthorizedPage: React.FC = () => (
  <div className="enhanced-registration-container">
    <div className="registration-panel">
      <div className="form-header">
        <h1>Access Denied</h1>
      </div>
      <div className="status-feedback-box">
        <div className="status-message error">
          <span className="status-text">
            You don't have permission to access this page. Please contact an administrator if you believe this is an error.
          </span>
        </div>
        <div className="form-footer">
          <button 
            onClick={() => window.location.href = '/login'}
            className="enhanced-submit-btn"
          >
            Return to Login
          </button>
        </div>
      </div>
    </div>
  </div>
)



function App() {
  return (
    <SmartRouterProvider>
      <div className="App">
        <Router />
      </div>
    </SmartRouterProvider>
  )
}

// Simple Router Component
const Router: React.FC = () => {
  const { currentPath } = useRouter()
  
  // Debug: Log current path
  console.log('Current path:', currentPath)
  
  switch (currentPath) {
    case '/login':
      return <LoginPage />
    case '/register':
      return <EnhancedRegistrationForm />
    case '/dashboard':
      return (
        <ProtectedRoute requireAuth={true}>
          <UnifiedDashboard />
        </ProtectedRoute>
      )
    case '/create-certificate':
      return (
        <ProtectedRoute requireAuth={true}>
          <CertificateCreationForm />
        </ProtectedRoute>
      )
    case '/certificates':
      return (
        <ProtectedRoute requireAuth={true}>
          <CertificateList />
        </ProtectedRoute>
      )
    case '/upload-images':
      return (
        <ProtectedRoute requireAuth={true}>
          <PhotoUpload />
        </ProtectedRoute>
      )
    case '/pending-approval':
      return (
        <ProtectedRoute requireAuth={true}>
          <PendingApprovalPage />
        </ProtectedRoute>
      )
    case '/unauthorized':
      return <UnauthorizedPage />
    case '/404':
      return <NotFoundPage />
    case '/':
    default:
      // Check if it's a public certificate URL (8-character UUID pattern)
      if (currentPath.match(/^\/[A-Z0-9]{8}$/)) {
        return <PublicCertificatePage />
      }
      return <LoginPage />
  }
}

export default App 